<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ 'EDIT_AMOUNT.APPLY_DISCOUNT' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="cross-icon"/>
    </div>
  </div>

  <nz-tabset nzTabBarGutter="1" nzSize="small">
    <ng-container *ngFor="let tab of tabsGroup">
      <nz-tab [nzTitle]="tab?.label" (nzClick)="changeTab(tab?.value)"></nz-tab>
    </ng-container>
  </nz-tabset>

  <div class="dialog-container">
    <div class="discount-container">
      <label>{{ 'EDIT_AMOUNT.SELECT_ITEM_QUANTITY' | fallbackTranslate }}</label>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="3">
          <img src="{{ data?.item?.image_pat }}" class="circle-dot-48 mr-10"
          (error)="utilService.handleImageError($event, images.PAN)" alt="dish-icon"/>
        </div>
        <div class="fs-18 fw-500 m-r-10" nz-col nzXs="10" nzSm="10" nzMd="12" nzLg="12">
          {{ data?.item?.item_name }}
          <div class="variant">
            <span *ngIf="data?.item?.variation_name !== ''">
              {{ 'ORDER_DASHBOARD.VARIANTS' | fallbackTranslate
              }}{{ data?.item.variation_name }}
            </span>
            <span *ngIf="data?.item?.addons_name !== ''">
              {{ 'ORDER_DASHBOARD.ADDONS' | fallbackTranslate
              }}{{ data?.item.addons_name }}
            </span>
            <div *ngIf="data?.item?.item_discount">
              {{ 'EDIT_AMOUNT.DISCOUNT' | fallbackTranslate }}:
              {{ data?.item?.item_discount?.type === 'fixed' ? Currency : '' }}
              {{ data?.item?.item_discount?.value_text }}
              {{ data?.item?.item_discount.type === 'percent' ? '% ' : '' }} -
              {{ data?.item?.item_discount?.reason }}
            </div>
          </div>
        </div>
        <div nz-col nzXs="10" nzSm="10" nzMd="8" nzLg="8">
          <nz-button-group class="m-r-10">
            <button nz-button nzType="primary" nzGhost nzSize="large" (click)="removeItem()" class="fs"
              [disabled]="itemQuantity === 1 ? true : null">
              <i class="fa fa-minus"></i>
            </button>
            <button nz-button nzType="primary" nzGhost nzSize="large" class="fs">
              {{ itemQuantity }}
            </button>
            <button nz-button nzType="primary" nzGhost nzSize="large" class="fs" (click)="addItem()" [disabled]="
                data?.item?.item_quantity === itemQuantity ||
                data?.item?.quantity === this.itemQuantity
                  ? true
                  : null
              ">
              <i class="fa fa-plus"></i>
            </button>
          </nz-button-group>
        </div>
      </div>
    </div>
    <div class="discount-container">
      <label>
        {{ 'EDIT_AMOUNT.SELECT_DISCOUNT_AMOUNT_PER_ATOM' | fallbackTranslate }}
      </label>
      <div class="discount-card-grid">
        <div class="discount-card flex-center" *ngFor="
            let item of this.currentTab === 'fixed'
              ? this.flatDiscount
              : this.percentageDiscount
          " (click)="discountClicked(item)" [ngClass]="
            selectedDiscount === item?.name ? 'discount-card-selected' : null
          ">
          {{ item?.name }}
        </div>

        <div class="discount-card-input-box c-pointer" (click)="discountClicked({ name: 'custom_discount' })" [ngClass]="
            selectedDiscount === 'custom_discount'
              ? 'discount-card-selected'
              : null
          " nz-popover nzPopoverTrigger="click" nzPopoverPlacement="right" [nzPopoverContent]="virtualKeyboard">
          <span class="prefix">
            {{ this.currentTab === 'fixed' ? Currency : '%' }}
          </span>
          <input type="text" #customInput [(ngModel)]="customDiscountValue" (keypress)="inputChanges($event)"
            inputmode="none" placeholder="{{ 'PLACEHOLDERS.ENTER_DISCOUNT_VALUES' | fallbackTranslate }}" />
        </div>
      </div>
    </div>

    <div class="discount-container">
      <label for="">{{ 'EDIT_AMOUNT.SELECT_REASON' | fallbackTranslate }}</label>
      <div class="discount-card-grid">
        <div class="discount-card flex-center" *ngFor="let reason of reasonPresets" (click)="reasonClicked(reason)"
          [ngClass]="
            selectedReason === reason?.label ? 'discount-card-selected' : null
          ">
          {{ reason?.label }}
        </div>
        <div class="discount-card-input-box c-pointer" (click)="reasonClicked()" [ngClass]="
            selectedReason === 'other_reason' ? 'discount-card-selected' : null
          ">
          <input type="text" [(ngModel)]="customReason" maxlength="30"
            placeholder="{{ 'PLACEHOLDERS.ENTER_OTHER_REASONS' | fallbackTranslate }}" />
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="save r-background" nz-button (click)="onRemoveDiscount()">
      {{
      (data?.item?.item_discount ? 'REMOVE_DISCOUNT' : 'CLOSED') | fallbackTranslate
      }}
    </button>
    <button nz-button class="save g-background" [nzLoading]="isBtnLoading" (click)="submit(true)">
      {{ 'EDIT_AMOUNT.APPLY' | fallbackTranslate }}
    </button>
  </div>
</div>

<ng-template #virtualKeyboard>
  <app-virtual-keyboard [showTripleZeros]="currentTab !== 'percent'" (numberEntered)="getNumber($event)" (numBackClicked)="numBack($event)"
    (decimalClicked)="getDecimal($event)"></app-virtual-keyboard>
</ng-template>